import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import infiniteScroll from 'vue-infinite-scroll';
import mask from './mask.js';
import Toggle from 'bootstrap-directives/toggle';
import Modal from 'bootstrap-directives/modal';
import Scrollspy from 'bootstrap-directives/scrollspy';
import Tooltip from 'bootstrap-directives/tooltip';
import Popover from 'bootstrap-directives/popover';

export default function() {
  Vue.use(Toggle);
  Vue.use(Modal);
  Vue.use(Scrollspy);
  Vue.use(Tooltip);
  Vue.use(Popover);
  Vue.use(vClickOutside);
  Vue.use(infiniteScroll);
  Vue.directive('focus', {
    inserted(el) {
      el.focus();
    }
  });
  mask();
}
